import { useScroll } from "framer-motion";
import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { isValidArray } from "../../../Layout/Common/common";
import { FavouriteListCard } from "../../../Skeleton/FavouriteListCard";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { MyFavCard } from "./myFavCard";
import { CreateNewListPopup } from "./createNewListPopup";
import { PAGES } from "../../../routeConfig";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { BacktoMyAccount } from "../backToMyAccount";

export const MyFavouriteListContainer = () => {
  const [myFavouriteList, setMyFavouriteList] = useState(null);
  const [search, setSearch] = useState("");
  const { wishListAll, setWishListAll } = useContext(GlobalContext);
  const { getAllWishList } = useGlobalFunction();

  useEffect(() => {
    if (myFavouriteList) setMyFavouriteList(wishListAll);
  }, [wishListAll]);

  useEffect(() => {
    const getWhislist = async () => {
      const response = await getAllWishList();
      if (response) {
        setWishListAll(response);
        setMyFavouriteList(response);
      }
    };
    getWhislist();
  }, []);

  const handleOnSearchType = (e) => {
    setSearch(e.target.value);
    if (wishListAll) {
      setMyFavouriteList(
        wishListAll.filter((item) => item.listName.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    }
  };

  return (
    <div className="container-fluid container-lg">
      <div className="row">
        <div className="col-lg-12">
          <div className="acc-header py-3">
            <div className="myaccount-address myAccount-header-info">
              <h1 className="myaccount-title">My Favourite Products</h1>
              <div className="order-invoice myFavoriteList">
                <p>You can find your favorite product list groups here</p>
              </div>
            </div>
            <div className="fav-search">
              <div className="input-group orders-search p-0 m-0">
                <i className="fa-solid fa-magnifying-glass" />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search List"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  onChange={handleOnSearchType}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <TransitionGroup className={"row row-equal-coloumn"}>
        <CreateNewListPopup />
        {myFavouriteList
          ? isValidArray(myFavouriteList) &&
            myFavouriteList.map((row, index) => (
              <CSSTransition key={row.listId} timeout={500} classNames="fade">
                <div className="col-md-6 col-xxl-3 col-lg-4 mt-3 mt-lg-4" key={row.listId}>
                  <MyFavCard item={row} index={row.listId} />
                </div>
              </CSSTransition>
            ))
          : Array.from({ length: 4 }).map((_, i) => (
              <CSSTransition key={i + 10} timeout={500} classNames="fade">
                <FavouriteListCard key={i} />
              </CSSTransition>
            ))}
      </TransitionGroup>
      <BacktoMyAccount />
    </div>
  );
};
